import { createApiRef } from '@backstage/core-plugin-api';
import type { ActivityLogClient } from './api';

export const activityLogApiRef = createApiRef<ActivityLogClient>({
  id: 'plugin.activity-log.service',
});
